/*
 * Australian Luxury Wool – Judge.me store review fallback
 * On product pages: if "Product reviews (0)" and "Store reviews (N>0)",
 * switch the Judge.me widget to the Store reviews tab automatically.
 * Runs once per page load and never overrides a tab the shopper clicked.
 */
(function () {
  if (window.__alwStoreReviewFallbackV2) return;
  window.__alwStoreReviewFallbackV2 = true;

  var PRODUCT_TAB_ID = 'jdgm-tab_product_reviews';
  var STORE_TAB_ID = 'jdgm-tab_shop_reviews';
  var DROPDOWN_SELECTOR = 'select.jdgm-tab-dropdown__select'; // mobile tab dropdown
  var MAX_WAIT_MS = 120000;

  var done = false;
  var shopperClicked = false;
  var debounce = null;

  function count(el) {
    var m = (el.textContent || '').match(/\(\s*([\d,]+)\s*\)/);
    return m ? parseInt(m[1].replace(/,/g, ''), 10) : null;
  }

  function stop() {
    done = true;
    observer.disconnect();
    clearTimeout(debounce);
  }

  function check() {
    if (done) return;
    if (shopperClicked) return stop();

    var productTab = document.getElementById(PRODUCT_TAB_ID);
    var storeTab = document.getElementById(STORE_TAB_ID);
    if (!productTab || !storeTab) return;

    var productCount = count(productTab);
    var storeCount = count(storeTab);
    // Wait until Judge.me has rendered real counts.
    if (productCount === null || !(storeCount > 0)) return;

    stop();
    if (productCount > 0) return; // product has its own reviews – leave as is
    if (storeTab.getAttribute('aria-selected') === 'true') return;

    if (storeTab.offsetParent !== null) {
      storeTab.click();
    } else {
      // Tabs hidden (e.g. mobile layout) – use the dropdown instead.
      var select = document.querySelector(DROPDOWN_SELECTOR);
      if (select) {
        select.value = 'shop_reviews';
        select.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        storeTab.click();
      }
    }
  }

  // If the shopper picks a review tab before we act, respect their choice.
  function markShopper(e) {
    if (!e.isTrusted || done) return;
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('#' + PRODUCT_TAB_ID + ',#' + STORE_TAB_ID + ',' + DROPDOWN_SELECTOR)) {
      shopperClicked = true;
    }
  }
  document.addEventListener('click', markShopper, true);
  document.addEventListener('change', markShopper, true);

  var observer = new MutationObserver(function () {
    if (debounce) return;
    debounce = setTimeout(function () { debounce = null; check(); }, 200);
  });

  function start() {
    observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
    setTimeout(function () { if (!done) stop(); }, MAX_WAIT_MS);
    check();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();